export function Field({
  label,
  children,
  hint,
  className = 'col-span-12 md:col-span-6',
  compact = false,
}) {
  return (
    <div className={className}>
      <label
        className={
          compact
            ? 'mb-1 block text-[11px] font-semibold uppercase tracking-[0.08em] text-[rgb(var(--muted))]'
            : 'mb-1 block text-sm font-medium text-[rgb(var(--fg))]'
        }
      >
        {label}
      </label>
      {children}
      {hint ? (
        <p className={compact ? 'mt-1 text-[11px] text-muted' : 'mt-1 text-xs text-muted'}>{hint}</p>
      ) : null}
    </div>
  );
}
